Solution1.vue<template>
	<Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
		<!-- Start Slider area -->
		<div class="slider-area slider-style-2 variation-2 height-450 bg_image"
				 :style="{'background-image': `url(${require(`@/assets/images/bwt/solution2-banner.jpg`)})`}">
			<div class="container">
				<div class="row">
					<div class="col-lg-8 col-xl-6">
						<div class="inner text-start" data-aos="fade-up" data-aos-delay="100">
							<h2 class="w-600 title text-left">运营商</h2>
							<h4 class="text-left color-white">提供安全稳固的算力网络基座，搭建敏捷创新的云原生平台</h4>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap sbg">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">运营商行业</h2>
				<div style="margin-top: 48px; font-size: 18px">
					运营商既是数字化转型的先行者，也面临诸多挑战。推动云网融合和算网一体的进程中，公司在算力基础设施、智算中心建设与运维、系统应用开发平台的搭建等多方面，与运营商客户协同创新，助力转型更快、更稳推进。
				</div>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">解决方案</h2>
				<div class="solution" data-aos="fade-up" data-aos-delay="100">
					<div class="pic">
						<img src="@/assets/images/bwt/s2-1.jpg" style="border-radius: 12px;">
					</div>
					<div class="txt" >
						<div class="t1">为运营商提供算力支撑</div>
						<div class="t2">依靠多样性的算力产品，帮助运营商打通通用计算节点、存储节点和安全节点，提供虚拟机、大数据存储、云底座管控、云内安全等服务。</div>
					</div>
				</div>
				<div class="solution" data-aos="fade-up" data-aos-delay="100">
					<div class="txt" >
						<div class="t1">整机柜助力运营商节能提效</div>
						<div class="t2">提供灵活定制的整机柜方案，以千变万化的节点组合满足不同的客户需求，帮助运营商客户从容应对密集计算、海量数据存储、人工智能等多样性场景，实现按需调用、节能环保。</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/bwt/s2-2.jpg" style="border-radius: 12px;">
					</div>
				</div>
				<div class="solution" data-aos="fade-up" data-aos-delay="100">
					<div class="pic">
						<img src="@/assets/images/bwt/s2-3.jpg" style="border-radius: 12px;">
					</div>
					<div class="txt" >
						<div class="t1">AI服务器参与智算中心建设</div>
						<div class="t2">提供具备高计算密度、高能效比、高网络带宽、易扩展、易管理等优点的AI服务器，帮助智算中心客户搭建网络云、移动云、IT云，云设计、云游戏、云渲染等领域的算力应用。</div>
					</div>
				</div>
				<div class="solution" data-aos="fade-up" data-aos-delay="100">
					<div class="txt" >
						<div class="t1">云原生PaaS平台提升研发效率</div>
						<div class="t2">为包括运营商在内的大中型企业量身定制，集成容器、微服务、DevOps等核心能力，提供自动化部署、弹性伸缩和可视化运维的一站式服务。</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/bwt/s2-4.jpg" style="border-radius: 12px;">
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Separator from '@/components/elements/separator/Separator'

export default {
	name: 'Solution1',
	components: {Separator, Layout},
	data() {
		return {

		}
	},
}
</script>
<style lang="scss" scoped>
.sbg {
	background-image: url("../../../assets/images/bwt/sbg.jpg");
}
.solution {
	margin-top: 72px;
	display: flex;
	.pic {
		width: 40%
		img {
			width: 100%;
		}
	}
	.txt {
		flex: 1;
		margin: 40px 36px;
		.t1 {
			font-size: 24px;
			font-weight: 600;
			color: #000;
		}
		.t2 {
			margin-top: 12px;
			color: #000;
		}
	}

}
</style>
